module.exports = __webpack_public_path__ + "static/img/服务.756ade7e.png";